import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { SpecraCombobox, SpecraText } from '@mono/ui-components';
import { Testids } from '@mono/ui-selectors';
import { useState } from 'react';
import { eventDescription, useEvents } from './eventHooks';
import { NewEventDialog } from './NewEventDialog';
const ids = Testids.eventCombobox;
function describe(e) {
    return [
        eventDescription(e),
        e.hostLabel
    ].filter(Boolean).join(' · ');
}
/**
 * GRW-36 event picker: server-side title search over ListEvents, with
 * "New event…" opening NewEventDialog and selecting what it creates.
 */ export function EventCombobox({ label = 'At an event', value, selectedTitle, onChange, canCreate = false, description, opportunityId }) {
    const [query, setQuery] = useState('');
    const [dialog, setDialog] = useState({
        open: false,
        title: ''
    });
    const [created, setCreated] = useState();
    const events = useEvents({
        search: query
    });
    const options = (events.data ?? []).map((e)=>({
            value: e.id,
            label: e.title,
            description: describe(e) || undefined
        }));
    const createdOption = created && created.id === value ? {
        value: created.id,
        label: created.title,
        description: describe(created) || undefined
    } : undefined;
    return /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            /*#__PURE__*/ _jsx(SpecraCombobox, {
                label: label,
                placeholder: "Search events",
                searchPlaceholder: "Search events by title",
                emptyMessage: events.isError ? 'Events could not be loaded' : 'No matching events',
                loading: events.isFetching,
                value: value || undefined,
                selectedOption: createdOption,
                fallbackLabel: selectedTitle || undefined,
                onValueChange: (v)=>onChange(v ?? '', events.data?.find((e)=>e.id === v)),
                onSearchValueChange: setQuery,
                shouldFilter: false,
                clearable: true,
                options: options,
                triggerProps: {
                    'data-testid': ids.trigger
                },
                getOptionTestId: ()=>ids.option,
                createTestId: ids.create,
                canCreate: ()=>canCreate,
                onCreate: (q)=>setDialog({
                        open: true,
                        title: q
                    }),
                createLabel: (q)=>q ? `New event “${q}”` : 'New event…'
            }),
            description && /*#__PURE__*/ _jsx(SpecraText, {
                as: "p",
                size: "meta",
                tone: "muted",
                children: description
            }),
            events.isError && /*#__PURE__*/ _jsx(SpecraText, {
                as: "p",
                size: "meta",
                tone: "danger",
                role: "alert",
                "data-testid": ids.error,
                children: "Events could not be loaded. Try again."
            }),
            /*#__PURE__*/ _jsx(NewEventDialog, {
                open: dialog.open,
                onOpenChange: (open)=>setDialog((d)=>({
                            ...d,
                            open
                        })),
                initialTitle: dialog.title,
                opportunityId: opportunityId,
                onCreated: (event)=>{
                    setCreated(event);
                    setQuery('');
                    onChange(event.id, event);
                }
            })
        ]
    });
}
